// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1SJ2d","header":"MessagesList_header__12Oy2","chat":"MessagesList_chat__2L9IQ"};